module.exports = __webpack_public_path__ + "static/media/contact-img.82b250a2.svg";